"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
var classNameRe = /nef-accept-custom-class-or-style/;
function withStyleAlerts(Component) {
    var displayName = Component.displayName;
    var C = react_1.default.forwardRef(function (props, ref) {
        react_1.default.useEffect(function () {
            var _a;
            if (process.env.NODE_ENV !== "production" &&
                !process.env.REACT_APP_SILENCE_ALL_NEF_STYLE_ALERTS &&
                !((_a = props.className) === null || _a === void 0 ? void 0 : _a.match(classNameRe))) {
                var getMsg = function (propName) {
                    return "Warning: It looks you passed a '" + propName + "' prop to the '" + displayName + "' component. Please be advised that any design issues arising from the use of custom style overrides on NEF components will NOT be supported by the NEF team. If you would like the '" + displayName + "' component to support additional features or functionality, please open a new issue here: https://git.nasdaq.com/nef/monorepo/issues/new. \n\nTo silence this alert, add 'nef-accept-custom-class-or-style' as a 'className' to the '" + displayName + "' component. \n\nTo silence all styling alerts, set the 'REACT_APP_SILENCE_ALL_NEF_STYLE_ALERTS' environment variable to 'true'. ";
                };
                if (props.className) {
                    console.warn(getMsg("className"), "\n\nIf your 'className' prop is intended for other uses (e.g. testing), you may safely ignore this message.");
                }
                if (props.style) {
                    console.warn(getMsg("style"));
                }
            }
        }, [props.className, props.style]);
        return react_1.default.createElement(Component, __assign({}, props, { ref: ref }));
    });
    C.displayName = "withAlerts(" + displayName + ")";
    return hoist_non_react_statics_1.default(C, Component);
}
exports.default = withStyleAlerts;
//# sourceMappingURL=index.js.map